import { Pagination, StatusMessageResponse } from '@shared/models';

export interface FetchUserListResponse extends StatusMessageResponse {
    current_page: number;
    results: any;
    data: UserListItemResponse[];
    last_page: number;
    first_page_url: string;
    per_page: number;
    total: number;
   
}

export interface UserListItemResponse {
  id: number;
  fullname: string;
  email: string;
  profile: string;
  company: string;
  id_number: string;
  status: string;
  // Legacy users can have a profile without its role row (e.g. superadmin with role_superadmin = null)
  role_admin: RoleAdmin | null;
  role_superadmin: RoleSuperadmin | null;
}

export interface RoleSuperadmin {
  created_at: string;
  deleted_at: string | null;
  firstname: string;
  id: number;
  lastname: string;
  status: string;
  updated_at: string;
  user_id: number;
}

export interface RoleAdmin {
    company: CompanyResponse | null;
    company_id: number;
    created_at: string;
    deleted_at: string | null;
    firstname: string;
    id: number;
    lastname: string;
    status: string;
    updated_at: string;
    user_id: number;
}

export interface CompanyResponse {
  created_at: string;
  deleted_at: string | null;
  id: number;
  name: string;
  updated_at: string;
}